<template>
    <div class="batch_wallpaper_container">
        <el-row class="p-list" :gutter="30">
            <el-col
                :xl="4"
                :lg="6"
                :md="8"
                :sm="12"
                class="p-list-item"
                v-for="(item, idx) in tableData"
                :key="idx">
                <div class="list_box p-image-wrap" @click="iocn_fun(idx)" @mouseenter="mouseenter(idx)" @mouseleave="mouseleave">
                    <div class="img_box">
                        <img :src="`${item.prev_url}?x-oss-process=image/resize,w_100`" alt="">
                    </div>
                    <div class="doc_box">
                        <p>
                            <span>版权来源 <span class="dic">{{item.source}}</span> </span>
                            <span>类型 <span class="dic">{{item.category}}</span> </span>
                        </p>
                        <p class="dio" v-if="checkStatus=='4'">
                            <span>是否首页显示 <span class="dic" :style="{color:set_is_top_color(item.is_top)}">{{item.is_top=='1'?'显示':'不显示'}}</span> </span>
                            <span>权重 <span class="dic">{{activeName=='1'?item.top_sort:item.sort}}</span> </span>
                        </p>
                        <p class="dio" v-if="checkStatus=='1'">
                            <span>通过状态 <span class="dic" :style="{color:set_color(item.lock_status)}">{{item.lock_status=='0'?'免费':(item.lock_status=='1'?'会员':'限免')}}</span> </span>
                        </p>
                    </div>
                    <div class="mock_box hover-class" v-if="idx==show_index || item.checked">
                        <p class="icon_p">
                            <i class="el-icon-success" :class="item.checked?'icon_color':''"></i>
                        </p>
                        <p class="zoom_p">
                            <el-button size="mini" @click.stop="viewBigImage(item)">
                                <i class="el-icon-zoom-in"></i>
                                大图
                            </el-button>
                        </p>
                    </div>
                        <el-image
                            :ref="`picture-${item.id}`"
                            :preview-src-list="[item.prev_url]"
                            :src="`${item.prev_url}?x-oss-process=image/resize,w_100`">
                        </el-image>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    props:{
        tableData:Array,
        check_arr:Array,
        checkStatus:String,
        activeName:String,
    },
    data(){
        return{
            show_index:-1,
            imgList:[],
            showViewer:false,
            img:'',
            // check_arr : []
        }
    },
    methods:{
        set_is_top_color(val){
            switch(val) {
                case '0':
                    return '#FF0000'
                case '1':
                    return '#33B3FF'
                default:
                    // 默认代码块
                    return '#000'
            } 
        },
        set_color(val){
            switch(val) {
                case '0':
                    return '#52be80'
                case '1':
                    return '#33B3FF'
                case '2':
                    return '#ff3333'
                default:
                    // 默认代码块
                    return '#000'
            } 
        },
        //对象数组中根据id/其他属性值判断是否有某条数据，有就删除，没有就添加
        sum(arr,itme)  {
            var isTrue = arr.some((currentValue, indexs) => {
                return currentValue.id === itme.id;
            })

            if(isTrue){
                arr.forEach((val,index)=>{
                if(val.id == itme.id){
                    arr.splice(index,1)
                }
            })
            }else{
                arr.push(itme)
            }
            return arr
        },
        viewBigImage(item) {
            this.$refs[`picture-${item.id}`][0].showViewer = true
        },
        iocn_fun(index){
            let tableData = JSON.parse(JSON.stringify(this.tableData))
            tableData[index].checked = !tableData[index].checked
            
            this.check_arr = this.sum(this.check_arr,tableData[index])

            this.$emit('set_tableData',tableData)
            this.$emit('get_check_arr',this.check_arr)
            console.log(this.check_arr,'this.check_arr')
        },
        mouseenter(index){
            this.show_index = index
        },
        mouseleave(){
            this.show_index = -1
        }
    }
}
</script>

<style lang="scss" scoped>
.batch_wallpaper_container{
    flex: 1;
    overflow-y: auto;
    width: 100%;
    overflow-x: hidden;
    padding-bottom: 100px;
    .p-list{
        .p-list-item{
            margin: 20px 0;
            cursor: pointer;
            .list_box{
                background: #ddd;
                position: relative;
                box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.2);
                &:hover {
                    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.2);
                }
                .img_box{
                    display: flex;
                    justify-content: center;
                    img{
                        width: 100px;
                    }
                }
                .doc_box{
                    background: #fff;
                    p{
                        display: flex;
                        justify-content: space-between;
                        padding: 20px 10px;
                        .dic{
                            color: #5eb8f5;
                        }
                    }
                    .dio{
                        padding-top: 0;
                        .dic{
                            color: #5eb8f5;
                        }
                    }
                }
                .mock_box{
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background-color: rgba(0, 0, 0, 0.5);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex-direction: column;
                    transition: 1s;
                    .icon_p{
                        .el-icon-success{
                            font-size: 50px;
                            color: #fff;
                            cursor: pointer;
                            &.icon_color{
                                color: #67c23a;
                            }
                        }
                    }
                    .zoom_p{
                        margin-top: 20px;
                    }
                }
            }
        }
    }
}
</style>

<style lang="scss">
.batch_wallpaper_container{
    .p-image-wrap{
        position: relative;
        align-items: center;
        background-color: #ddd;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        overflow: hidden;
    }
    .el-image {
            width: 100%;
            height: 100%;
            display: block;
            >img{
                width: auto;
                height: auto;
                max-width: 100%;
                max-height: 100%;
                transform: translate(-50%, -50%);
                position: absolute;
                left: 50%;
                top: 50%;
            }
        }
        }
</style>
